import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.jpeg';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-grain" />
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo-row">
              <img src={logo} alt="SSE Logo" className="footer-logo" />
              <div>
                <div className="footer-brand-name">Sri Sai Engineerings</div>
                <div className="footer-brand-tagline">World of Rice Mill Machinery</div>
              </div>
            </div>
            <p className="footer-desc">
              Over three decades of pioneering superior quality Modern Rice Mill Machinery,
              making rice milling more profitable for mills across India and beyond.
            </p>
            <div className="footer-social">
              <a href="mailto:srisaiengs@gmail.com" className="social-pill">Email Us</a>
              <a href="tel:+919848027990" className="social-pill">Call Now</a>
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Products</h4>
            <ul>
              <li><Link to="/products">Paddy Cleaner</Link></li>
              <li><Link to="/products">Pneumatic Husker</Link></li>
              <li><Link to="/products">Whitener</Link></li>
              <li><Link to="/products">Silky Polisher</Link></li>
              <li><Link to="/products">Rice Shifter</Link></li>
              <li><Link to="/products">Geared Elevators</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Contact</h4>
            <div className="footer-contact-item">
              <span className="contact-icon">📍</span>
              <span>D.No.1-43 Opp: Rajya Lakshmi Theatre, Uppal, Hyderabad – 500 039</span>
            </div>
            <div className="footer-contact-item">
              <span className="contact-icon">📞</span>
              <span>9848027990 , 9948127994</span>
            </div>
            <div className="footer-contact-item">
              <span className="contact-icon">📱</span>
              <span>9848782799</span>
            </div>
            <div className="footer-contact-item">
              <span className="contact-icon">✉️</span>
              <span>srisaiengs@gmail.com</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Sri Sai Engineerings. All rights reserved.</p>
          <p className="footer-bottom-tag">MFG. Modern Rice Mills | Hyderabad, India</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
